<template>
  <div class="follow-box" v-loading="loading">
    <div class="tab-box df aic">
      <span class="mr-46 cup" :class="{ active: activeTab === 'follow' }" @click="switchTab('follow')">
        {{ $t('我的关注') }}
        <em class="tab-count fs-14">({{ followTotal }})</em>
      </span>
      <span class="mr-46 cup" :class="{ active: activeTab === 'fans' }" @click="switchTab('fans')">
        {{ $t('我的粉丝') }}
        <em class="tab-count fs-14">({{ fansTotal }})</em>
      </span>
    </div>
    <div v-if="list.length" class="list">
      <div class="row df aic" v-for="item in list" :key="item.user_id" @click="openUser(item)">
        <el-avatar :size="44" :src="item.user_avatar_att_url">
          <img src="@/assets/images/avatar.png" alt="">
        </el-avatar>
        <div class="info f1 over-h">
          <p class="name one-text">{{ item.user_nick_name || $t('匿名用户') }}</p>
          <div class="tags one-text" v-if="item.user_excel_arr && item.user_excel_arr.length">
            <span v-for="tag in item.user_excel_arr" :key="tag.value || tag.label">{{ tag.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="no-data" v-else-if="!loading">
      <img src="@/assets/images/empty_data.png" alt="" />
      <p>{{ $t('暂无数据') }}</p>
    </div>
    <div class="pageing-box df aic jcc" v-if="currentTotal > pageSize">
      <el-pagination
        :current-page="page"
        :page-size="pageSize"
        :total="currentTotal"
        layout="prev, pager, next"
        @current-change="handlePage"
      />
    </div>
    <avatar-dialog ref="avatarDialog" :id="currentUserId" @post-submitted="handleFollow" />
  </div>
</template>

<script>
import { getMyFollow, getMyFans } from "@api/usercenter";
import { setuserfollowAdd } from "@api/home";
import avatarDialog from "@comp/avatar.vue";

export default {
  name: "PersonalFollow",
  components: { avatarDialog },
  data() {
    return {
      loading: false,
      activeTab: "follow",
      list: [],
      page: 1,
      pageSize: 10,
      followTotal: 0,
      fansTotal: 0,
      currentUserId: 0,
    };
  },
  computed: {
    /**
     * 当前 Tab 的总数，用于分页
     * @returns {number}
     */
    currentTotal() {
      return this.activeTab === "fans" ? this.fansTotal : this.followTotal;
    },
  },
  mounted() {
    this.load();
    this.loadOtherCount();
  },
  methods: {
    /**
     * 切换关注/粉丝 Tab
     * @param {string} tab follow | fans
     */
    switchTab(tab) {
      if (this.activeTab === tab) return;
      this.activeTab = tab;
      this.page = 1;
      this.list = [];
      this.load();
    },
    /**
     * 把接口返回的 total 写到对应 Tab
     * @param {string} tab follow | fans
     * @param {number} total 总数
     */
    setTabTotal(tab, total) {
      if (tab === "fans") {
        this.fansTotal = total;
      } else {
        this.followTotal = total;
      }
    },
    /**
     * 加载当前 Tab 列表，并更新该 Tab 总数
     */
    async load() {
      this.loading = true;
      try {
        const api = this.activeTab === "fans" ? getMyFans : getMyFollow;
        const res = await api({ page: this.page, pagesize: this.pageSize });
        if (res && res.status == 200) {
          const pageData = res.data || {};
          this.list = pageData.data || [];
          this.setTabTotal(this.activeTab, pageData.total || 0);
        } else {
          this.list = [];
          this.setTabTotal(this.activeTab, 0);
        }
      } finally {
        this.loading = false;
      }
    },
    /**
     * 加载另一侧 Tab 的总数，保证两个数字同时可见
     */
    async loadOtherCount() {
      const otherTab = this.activeTab === "fans" ? "follow" : "fans";
      const api = otherTab === "fans" ? getMyFans : getMyFollow;
      const res = await api({ page: 1, pagesize: 1 });
      if (res && res.status == 200) {
        this.setTabTotal(otherTab, (res.data && res.data.total) || 0);
      }
    },
    /**
     * 分页切换
     * @param {number} page 页码
     */
    handlePage(page) {
      this.page = page;
      this.load();
    },
    /**
     * 打开用户资料弹窗
     * @param {object} item 用户信息
     */
    openUser(item) {
      this.currentUserId = item.user_id;
      this.$nextTick(() => {
        this.$refs.avatarDialog.openModal();
      });
    },
    /**
     * 关注/取消关注后刷新列表和两侧总数
     * @param {number|string} id 被关注用户 ID
     */
    async handleFollow(id) {
      const res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
      if (res && res.status == 200) {
        this.$message.success(res.msg);
        this.load();
        this.loadOtherCount();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.follow-box {
  min-height: 320px;
  padding: 8px 8px 24px;
}
.tab-box {
  margin-bottom: 16px;
  .cup {
    padding-bottom: 6px;
    position: relative;
    font-size: 18px;
    font-weight: 600;
    color: #191919;
    position: relative;
    &:hover {
      color: #b7251e;
    }
  }
  .tab-count {
    margin-left: 2px;
    font-style: normal;
    font-size: 16px;
    font-weight: 600;
    position: absolute;
    bottom: 9px;
  }
  .active {
    color: #b7251e;
    &::after {
      content: "";
      display: block;
      position: absolute;
      width: 80%;
      height: 2px;
      background: #b7251e;
      bottom: 0;
      left: 10%;
    }
  }
}
.row {
  padding: 14px 8px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  &:hover {
    background: #fafafa;
  }
}
.info {
  margin-left: 14px;
}
.name {
  font-size: 16px;
  color: #191919;
  margin: 0;
}
.tags {
  margin-top: 6px;
  span {
    display: inline-block;
    margin-right: 8px;
    padding: 0 8px;
    line-height: 22px;
    font-size: 12px;
    color: #b7251e;
    background: #fff1f0;
    border-radius: 4px;
  }
}
.no-data {
  text-align: center;
  padding: 48px 0;
  color: #999;
  img {
    width: 160px;
  }
}
.pageing-box {
  margin-top: 20px;
}
</style>
